import * as React from 'react';
import { classes } from './offering-description.st.css';
import { OfferingIntent } from '../../../../constants';
import { WIDGET_BI_REFERRAL } from '../../../../adapters/reporting/bi-logger/bi.const';
import OfferingAction from '../offering-action/offering-action';

export const MAX_DESCRIPTION = 170;

interface OfferingDescriptionProps {
  onAction(intent: string, biReferral: string): void;
  height?: number;
  shouldShowActionButton: boolean;
  description: string;
  alignmentStyle: string;
}

class OfferingDescription extends React.Component<OfferingDescriptionProps> {
  render() {
    const { alignmentStyle, height, description } = this.props;
    const descriptionModel = this.getDescriptionWithEllipsis(description);
    const containerStyle = height
      ? {
          height: `${height}px`,
        }
      : {};
    return (
      <div
        className={`${classes.root} ${alignmentStyle}`}
        style={containerStyle}
      >
        {descriptionModel ? (
          <div
            data-hook="tile-description"
            className={classes.descriptionContent}
            onClick={this.onDescriptionClicked}
          >
            <div
              className={`${classes.descriptionContentText}`}
              role="button"
              tabIndex={-1}
              aria-label={descriptionModel}
            >
              {descriptionModel}
            </div>
          </div>
        ) : null}
        {this.props.shouldShowActionButton ? (
          <div className={classes.descriptionAction}>
            <OfferingAction onAction={this.props.onAction} />
          </div>
        ) : null}
      </div>
    );
  }

  private getDescriptionWithEllipsis(description: string) {
    return description && description.length > MAX_DESCRIPTION
      ? `${description.substring(0, MAX_DESCRIPTION)}...`
      : description;
  }

  private readonly onDescriptionClicked = () =>
    this.props.onAction(
      OfferingIntent.SHOW_DETAILS,
      WIDGET_BI_REFERRAL.WIDGET_DESCRIPTION,
    );
}

export default OfferingDescription;
